import { ModalMode, UsersState, View } from '@/views/users/users.types';
import { initialUserFormState }        from '@/views/users/users.variables';

const state: UsersState = {
  statusOptions: [ 'Active', 'Inactive' ],
  serverErrors: [],
  view: View.TABLE,
  isDataLoading: true,
  users: [],
  modal: {
    open: false,
    mode: ModalMode.CREATE_USER,
    form: {
      selectedUuid: null,
      fields: initialUserFormState,
    },
  },
  table: {
    columns: [
      'login',
      'email',
      'firstName',
      'lastName',
      'position',
      'status',
      'actions',
    ],
  },
};

export default state;
